import { AdminRoles, AdminStatus } from '@/models/admins.model';

export enum AdminFiltersFields {
  EMAIL = 'email',
  NAME = 'full_name',
  ROLE = 'role',
  STATUS = 'status',
  PHONE_NUMBER = 'phone_number',
}

export enum AdminFormFieldsNames {
  EMAIL = 'email',
  NAME = 'full_name',
  ROLE = 'role',
  STATUS = 'status',
  PHONE_NUMBER = 'phone_number',
}

export type TAdminFormValues = {
  [AdminFormFieldsNames.EMAIL]: string;
  [AdminFormFieldsNames.NAME]: string;
  [AdminFormFieldsNames.ROLE]: AdminRoles;
  [AdminFormFieldsNames.STATUS]: AdminStatus;
  [AdminFormFieldsNames.PHONE_NUMBER]: string;
};

export type TAdminFiltersValues = {
  [AdminFiltersFields.ROLE]?: AdminRoles;
  [AdminFiltersFields.STATUS]?: AdminStatus;
  [AdminFiltersFields.EMAIL]?: string;
  [AdminFiltersFields.NAME]?: string;
  [AdminFiltersFields.PHONE_NUMBER]?: string;
  limit?: number;
  cursor?: string;
};
